import { render, staticRenderFns } from "./AttributeTableColumnForm.vue?vue&type=template&id=ab09e1bc&scoped=true"
import script from "./AttributeTableColumnForm.vue?vue&type=script&lang=ts"
export * from "./AttributeTableColumnForm.vue?vue&type=script&lang=ts"
import style0 from "./AttributeTableColumnForm.vue?vue&type=style&index=0&id=ab09e1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab09e1bc",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user/user-list.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fusers%2FAttributeTableColumnForm.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports